import { Button, Modal, Tag } from "@tvg/design-system";
import React from "react";
import { SafeAreaProvider } from "react-native-safe-area-context";
import { QA_LABELS } from "../../utils/constants";
import {
  Container,
  Description,
  EmptyPage,
  FeaturesDescription,
  FeaturesList,
  TagContainer,
  Timestamp,
  CTAButtonContainer
} from "./styled-components";
import { Props } from "./types";

const FeaturesPreview = ({
  list,
  description,
  onPress,
  isOpen,
  noFeaturesAvailable,
  config,
  onClose,
  timestamp,
  details,
  isViewingMore,
  toggleViewMore,
  onOverlayClose,
  theme
}: Props) => (
  <SafeAreaProvider>
    <Modal
      title="Beta Features"
      subtitle="Preview"
      maxWidth="960px"
      isOpen={isOpen}
      padding={0}
      qaLabel={QA_LABELS.BASE_MODAL}
      onClose={onClose}
      onOverlayClick={onOverlayClose}
    >
      <Container>
        <FeaturesList data-qa-label={QA_LABELS.FEATURES_LIST}>
          {list}
        </FeaturesList>
        {noFeaturesAvailable ? (
          <EmptyPage data-qa-label={QA_LABELS.EMPTY_CASE}>
            <p>No features available</p>
          </EmptyPage>
        ) : (
          <FeaturesDescription theme={theme}>
            <TagContainer theme={theme}>
              <Tag
                label={config.tagText}
                variant={config.tagVariant}
                size="l"
                qaLabel={QA_LABELS.STATUS_TAG}
                marginRight={8}
              />
              <Timestamp>{timestamp}</Timestamp>
            </TagContainer>
            <Description data-qa-label={QA_LABELS.ARTICLE} theme={theme}>
              {description}
              {details && (
                <>
                  <Button
                    onPress={toggleViewMore}
                    variant="tertiary"
                    qaLabel={`${QA_LABELS.CTA}-view-more`}
                    width="100%"
                    size="m"
                    marginX="auto"
                    marginBottom={16}
                  >
                    {!isViewingMore ? "View more" : "Hide"}
                  </Button>
                  {isViewingMore && details}
                </>
              )}
            </Description>
            <CTAButtonContainer theme={theme}>
              <Button
                qaLabel={`${QA_LABELS.CTA}-${config.ctaText}`}
                onPress={onPress}
                variant={config.ctaVariant}
                width="100%"
              >
                {config.ctaText}
              </Button>
            </CTAButtonContainer>
          </FeaturesDescription>
        )}
      </Container>
    </Modal>
  </SafeAreaProvider>
);

export default FeaturesPreview;
